

function applyOrientationClass(img) {
  const wrap = img.closest('.img-wrap');
  if (!wrap) return;
  wrap.classList.toggle('tate', img.naturalHeight > img.naturalWidth);
  wrap.classList.toggle('yoko', img.naturalWidth >= img.naturalHeight);
}

function initImageOrientation() {
  document.querySelectorAll('.img-wrap img').forEach((img) => {
    if (img.complete && img.naturalWidth) {
      applyOrientationClass(img); // キャッシュ済み対策
    } else {
      img.addEventListener('load', () => applyOrientationClass(img), { once: true });
      img.addEventListener('error', () => {
        // 画像読み込み失敗時のフォールバック（必要なら）
      }, { once: true });
    }
  });
}

// Shopifyテーマでの安定フック
window.addEventListener('load', initImageOrientation);
// セクション再描画等（OS2.0）
document.addEventListener('shopify:section:load', initImageOrientation);
document.addEventListener('shopify:section:reorder', initImageOrientation);
